<template>
  <div class="basic_video_index"
  @mouseenter="module_isHover(true)" @mouseleave="module_isHover(false)">
    <div class="tooptipPart module_edit_btn" v-if="isHover">
      <my_hover_btn :tips="$t('widgets_basic_article_classification_index_336')" btnIcon="el-icon-edit" @changeStyle="edit_module"></my_hover_btn>
      <my_hover_btn :tips="$t('widgets_basic_article_classification_edit_330')" btnIcon="el-icon-magic-stick" @changeStyle="animation_set" v-if="$store.state.app.view_pattern === 'pc'"></my_hover_btn>
      <my_close_btn :module="module" :column="column" :moduleIndex="module_index" v-if="$store.state.app.view_pattern === 'pc'"></my_close_btn>
    </div>
    <div class="basic_video" :style="{
      '--btnUrl':btnUrl,
    }">
      <my_title_index :title="widgets_infor.title"></my_title_index>
      <div class="flv_content module_content" :class="{flv_content_hover: pc_infor.play_mode.radio_val == 'default'}">
      <div class="online_flv" :style="{
        paddingBottom: pc_infor.height[pc_infor.height.radio_val].height
      }">
      <!-- 播放方式：弹窗播放-->
       <div class="img_flv_div" @click="openVideoDialog" v-if="pc_infor.play_mode.radio_val == 'default' && videoIsRender">
         <div class="flv_play_btn"  :class="{'flv_play_btn_anmation': [5, 6].includes(pc_infor.play_btn_url)}" @click="openVideoDialog" :style="{...play_icon}"></div>
           <!-- 无视频主图-->
            <div
             v-if="videoPic !== ''"
             class="video_poster_img"
             :style="{
               backgroundImage: 'url('+ videoPic +')'
             }">
             </div>
          <!-- 有视频主图-->
          <video style="width: 100%;"
          v-else
          class="video-js"
           :poster="videoPic">
            <source
              :src="pc_infor.pop_video[pc_infor.pop_video.type].url"
              type="video/mp4"
            >
          </video>
          </div>
          <!-- 添加视频类型：本地添加，播放方式：直接播放-->
        <div class="direct_play_flv"  :class="{'direct_play_flv_anmation': [5, 6].includes(pc_infor.play_btn_url)}" :style="{
          display: pc_infor.play_mode.radio_val == 'custom' && pc_infor.pop_video.type !== 'common_code' ? 'block': 'none'
        }">
          <video :id="'myVideo_' + module.widgets_id" class="video-js vjs-default-skin vjs-big-play-centered"
          
          preload="meta"
          muted
          height="300"
          :poster="videoPic"
          x5-video-player-fullscreen="true"
          x5-video-player-type="h5">
            <source :src="pc_infor.pop_video[pc_infor.pop_video.type].url"  type="video/mp4">
          </video>
        </div>
        <div v-if="pc_infor.play_mode.radio_val == 'custom'
        && pc_infor.pop_video.type == 'common_code'"
        v-html="pc_infor.pop_video.common_code.url"
        >
        </div>
      </div>
      <div class="flv_describe"
      v-if="pc_infor.pop_video.note !== ''"
      :style="{
        textAlign: pc_infor.text_set.custom.textAlign
      }">
        <span class="flv_describe_text" v-text="pc_infor.pop_video.note" :style="textStyle"></span>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import i18n from '../../language/index'

export default {
  name: 'basic_video',
  data() {
    return {
      isHover: false,
      videoIsRender: true
    };
  },
  methods: {
    module_isHover(val) {
      this.isHover = val;
    },
    openVideoDialog() {
      let pc_infor = this.module.data.pc_widgets_infor
      let type = pc_infor.pop_video.type
      let url = pc_infor.pop_video[type].url
      
      if(pc_infor.play_mode.radio_val == 'default') {
        if(url === ''){
          this.$message({showClose: true,message: i18n.t('widgets_basic_video_index_2884'),type: 'warning'});
          return false
        }
        this.$store.commit('app/set_video_dialog_isShow', true);
        this.$store.commit('app/set_video_data', {
          ...pc_infor.pop_video,
          play_btn_url: this.pc_infor.play_btn_url
        });
      } else {
        if(!pc_infor.play_mode.custom.autoplay) {
          const myVideo = $('#u'+ this.module.widgets_id).find('video')[0]
          if(myVideo.paused){
            myVideo.play();
          }
        }
      }
    },
    edit_module() { // 编辑模块
      this.templet.changeStyle(this.module,'style');
    },
    animation_set() { // 动画设置
      this.templet.changeStyle(this.module,'animation');
    },
    setVideoRender() {
      this.videoIsRender = false
      this.$nextTick(()=> {
        this.videoIsRender = true
        this.btnIsShow = true
      })
    },
    initVideo() {
    	let infor = this.pc_infor
    	let type = infor.pop_video.type
    	let play_mode = infor.play_mode.radio_val
    	let controls = true
      let autoplay = false
      let loop = false
      let url = infor.pop_video.video_address.url
    	if(play_mode =='custom' && type !== 'common_code') {
        if(type === 'local_add') {
          autoplay = infor.play_mode.custom.autoplay
          loop = infor.play_mode.custom.loop
          url = infor.pop_video.local_add.url
          if(infor.play_mode.custom.autoplay && infor.play_mode.custom.loop) {
          	controls = infor.play_mode.hidden_control === true ? false: true
          }
        } else {
          url = infor.pop_video.video_address.url
        }
        let data = {src:url,type: 'video/mp4'}
    	  let myPlayer = this.$video(('myVideo_'+ this.module.widgets_id), {
    				  controls: controls,
    				  muted: true,
    				  autoplay: autoplay,
    				  loop: loop,
    				  language: 'zh-CN', // 设置语言
    				  controlBar: {
    						  children: [{name: 'playToggle'},//播放暂停按钮
    							  {name: 'currentTimeDisplay'},
    							  {name: 'timeDivider'},//分隔符
    							  {name: 'durationDisplay'},// 总时间
    							  {name: 'progressControl'},// 播放进度条
    							  {name: 'volumePanel',inline: false},// 不使用水平方式// 音量控制
    							  {name: 'fullscreenToggle'}// 全屏
    						  ]
    					  },
                sources: []
    	  });
        myPlayer.src(data);
        myPlayer.load(data);
        if(infor.play_mode.custom.autoplay) {
          myPlayer.play()
        } else {
          myPlayer.pause()
        }
    	}
    }
  },
  props: {
    module: {
      type: Object,
      default: null
    },
    column: {
      type: Object,
      default: null
    },
    row: {
      type: Object,
      default: null
    },
    module_index: {
      type: Number,
      default: 0
    }
  },
  watch: {
    'pc_infor.play_mode': {
      handler(val) {
        if(val.radio_val === 'custom' && this.pc_infor.pop_video.type !== 'common_code') {
          this.initVideo()
        }
      },
     deep: true
    },
    'widgets_infor.pop_video.local_add.url'(val) {
      this.setVideoRender()
      if(this.pc_infor.play_mode.radio_val === 'custom') {
        this.initVideo()
      }
    },
    'videoPic'(val) {
      this.setVideoRender()
    },
    'pc_infor.pop_video.type'(val) {
      if(this.pc_infor.play_mode.radio_val === 'custom' && this.pc_infor.pop_video.type !== 'common_code') {
        this.initVideo()
      }
      this.setVideoRender()
    },
    'pc_infor.title_picture.radio_val'(val) {
      if(val === 'custom' && this.pc_infor.title_picture.custom.url === '') {
        this.$message.warning({
            showClose: true,
            message: i18n.t('widgets_basic_video_index_2885')
        });
        val = 'default'
      }
      this.setVideoRender()
    },
  },
  computed: {
    widgets_infor () {
      return  this.module.data[this.$store.state.app.view_pattern + '_widgets_infor']
    },
    pc_infor () {
      return  this.module.data.pc_widgets_infor
    },
    videoPic () {
      let infor = this.module.data.pc_widgets_infor
      let videoPic = ''
      if(infor.title_picture.radio_val === 'custom' && infor.title_picture.custom.url !== '') {
        videoPic = infor.title_picture.custom.url
      } else {
        if(infor.pop_video.type === 'common_code') {
          videoPic = 'https://staticjs.71360.com/3/static/txys-001/image/video.jpg'
        }
      }
      return videoPic
    },
    textStyle() {
      let infor = this.module.data.pc_widgets_infor
      let radio_val = infor.text_set.radio_val
      let pattern = infor.text_set[radio_val].pattern
      let color = infor.text_set[radio_val].fontColor
      let backgroundImage = ''
      let linear_gradient = infor.text_set[radio_val].linear_gradient
      if(pattern === 'linear_gradient'){
        color = 'transparent'
        backgroundImage = 'linear-gradient('+linear_gradient.deg + 'deg,' +linear_gradient.start_color + ' ' + linear_gradient.start_pointer + '%,' + linear_gradient.end_color + ' ' + linear_gradient.end_pointer +'%)'
      }
      let style = {
          fontStyle: infor.text_set[radio_val].fsItalics,
          textDecoration: infor.text_set[radio_val].fontUnderline,
          fontWeight: infor.text_set[radio_val].fsWeight,
          color: color,
          fontFamily: infor.text_set[radio_val].fontFamily,
          fontSize: infor.text_set[radio_val].fontSize + 'px',
          backgroundImage: backgroundImage,
          paddingRight: 10 + 'px'
      }
      return style
    },
    play_icon() {
      return this.pc_infor.play_btn_url ? ({
        background: `url(https://sitecdn.71360.com/static/txys-001/assets/wmsite-xys-img/play_icon/play_icon${this.pc_infor.play_btn_url}.png?v=1)`,
        
      }) : {}
    },
    btnUrl() {
      return `url(https://sitecdn.71360.com/static/txys-001/assets/wmsite-xys-img/play_icon/play_icon${this.pc_infor.play_btn_url}.png?v=2)`
    }
  },
  mounted() {
    let infor = this.module.data.pc_widgets_infor
    // 外文站没有通用代码
    if(this.$store.state.app.road_type == 1 && infor.pop_video.type == 'common_code') {
      this.$set(this.module.data.pc_widgets_infor.pop_video,'type','local_add')
    }
    if(infor.play_mode.radio_val == 'custom' && infor.pop_video.type !== 'common_code') {
      this.initVideo()
    }
   
    if (typeof this.pc_infor.play_btn_url == 'undefined') this.pc_infor.play_btn_url = 1
  }
};
</script>

<style lang="scss" scoped>
@keyframes play_anmation{
  0% {
    transform: scale(0.5);
  }
  100% {
    transform: scale(1);
  }
}
  .pc_pattern .flv_content .flv_play_btn{
    top: 50%;
    opacity: 1;
    transition: all 1s;
  }
  .mb_pattern {
    .basic_video_index .img_flv_div .flv_play_btn {
      top:50%;
      opacity: 1
    }
    .basic_video_index .module_content {
      padding: 3.2% 3.72%;
    }
  }
.basic_video_index {
  position: relative;
  box-sizing: border-box;
  min-height: 30px;
  min-width: 30px;
  height: 100%;
  .tooptipPart {
    right: 0;
    top: 0;
    display: block;
    z-index: 999;
  }
}
.basic_video {
  .textEdit {
    display: block;
    width: 100%;
    cursor: text;
    min-width: 10px;
    overflow: hidden;
    pointer-events: none;
  }
  /deep/ .video-js .vjs-big-play-button{
    font-size: 0 !important;
    background: var(--btnUrl) !important;
    width: 60px !important;
    height: 60px !important;
    margin-top: -30px !important;
    margin-left: -30px !important;
    border:none !important;
    background-size: 60px 60px !important;
  }
  .direct_play_flv_anmation {
    /deep/ .video-js .vjs-big-play-button{
      &::before{
        top: -10px;
        left: -10px;
        content: "";
        width: 80px;
        height: 80px;
        position: absolute;
        border-radius: 100%;
        background: rgba(255, 255, 255, 0.2);
        animation: 1.5s play_anmation linear infinite;
      }
      &::after{
        top: -35px;
        left: -35px;
        content: "";
        width: 130px;
        height: 130px;
        position: absolute;
        border-radius: 100%;
        background: rgba(255, 255, 255, 0.2);
        animation: 2s play_anmation linear infinite;
      }
    }
  }
  .flv_play_btn_anmation{
    &::before{
    top: -10px;
    left: -10px;
    content: "";
    width: 80px;
    height: 80px;
    position: absolute;
    border-radius: 100%;
    background: rgba(255, 255, 255, 0.2);
    animation: 1.5s play_anmation linear infinite;
    }
    &::after{
      top: -35px;
      left: -35px;
      content: "";
      width: 130px;
      height: 130px;
      position: absolute;
      border-radius: 100%;
      background: rgba(255, 255, 255, 0.2);
      animation: 2s play_anmation linear infinite;
    }
  }
  .flv_play_btn{
    background-size:60px 60px !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/widgets/basic_video/index.vue